import { AssignVideoBoardComponent } from './../assign-video-board/assign-video-board.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { StartMatchModule } from '../../match-tracker/start-match/start-match.module';
import { VideoStreamProviderListModule } from '../../video-stream-provider-list/video-stream-providers-list.module';
import { ShareMatchComponentModule } from '../../_shared/components/share-match/share-match.module';
import { MatchOptionsComponent } from '../match-options/match-options.component';

import { TrackerBarComponent } from './tracker-bar.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule.forChild(),
        ShareMatchComponentModule,
        StartMatchModule,
        VideoStreamProviderListModule,
        AssignVideoBoardComponent
    ],
    exports: [
        TrackerBarComponent
    ],
    declarations: [
        TrackerBarComponent,
        MatchOptionsComponent
    ],
    providers: [],
})

export class TrackerBarModule { }
